import axios from "axios"
import type { CognitoClientOptions } from "./CognitoClientOptions"
import type { TokenResponse } from "./TokenResponse"

export const fetchTokenWithRefreshToken = ({ clientId, host }: CognitoClientOptions, refreshToken: string) =>
	axios.post<TokenResponse>(
		`https://${host}/oauth2/token?grant_type=refresh_token&client_id=${clientId}&refresh_token=${refreshToken}`,
		{},
		{
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
		},
	)
